import { refAutoReset, syncRefs, useClipboard } from '@vueuse/core'
import { useDisplay, useLocale as useVuetifyLocale } from 'vuetify'
import { useBreakpoints } from './useBreakpoints'

export function useAutoResetClipBoard(source, afterMs = 1500) {
  const { text, copy: copyByClipboard, copied: copiedByClipboard, isSupported } = useClipboard({ source })
  const copiedAutoReset = refAutoReset(false, afterMs)
  // 不支援 clipboard 的時候使用
  const refCopied = ref(false)
  syncRefs(copiedByClipboard, refCopied, copiedAutoReset)
  const copied = computed(() => (isSupported.value ? copiedByClipboard.value : refCopied.value))

  function copyByCommend() {
    const input = document.createElement('input')
    document.body.appendChild(input)
    input.setAttribute('value', isRef(source) ? source.value : source)
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
  }

  async function copy() {
    await (isSupported.value ? copyByClipboard() : copyByCommend())
    refCopied.value = true
    copiedAutoReset.value = true
  }

  return { text, copy, copied, copiedAutoReset }
}

export const useVuetify = () => {
  const display = useDisplay()
  const { breakpoints } = useBreakpoints()
  const locale = useVuetifyLocale()
  // 如果不在 Vue instance 中呼叫就會取不到
  // if (!vm) throw new Error('This must be called within a setup function.')

  return {
    display: {
      ...display,
      ...toRefs(breakpoints),
    },
    locale,
  }
}
